import { IVideoPlayerProvider } from "./interfaces/video-player-provider";
import { scriptLoaderService } from "./script-loader.component";

export class YoutubeProvider implements IVideoPlayerProvider {
    private playerApiPromise = new Promise<void>((resolve) => {
        window.onYouTubePlayerAPIReady = (): void => {
            resolve();
        };
    });

    public createPlayer(frameId: string): Promise<unknown> {
        return scriptLoaderService.loadScript("https://www.youtube.com/player_api")
            .then(() => this.playerApiPromise)
            .then(() => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                const ytPlayer = new YT.Player(frameId);
                return Promise.resolve({
                    play: () => {
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                        ytPlayer.playVideo();
                    },
                    pause: () => {
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                        ytPlayer.pauseVideo();
                    }
                });
            });
    }

    public getPreviewImage(id: string): Promise<string> {
        return Promise.resolve(`https://img.youtube.com/vi/${id}/mqdefault.jpg`);
    }

    public getEmbedUrl(videoId: string, allowCookies: boolean, autoplay: boolean): string {
        const autoplayValue = Number(autoplay);

        if (allowCookies === true) {
            return `https://www.youtube.com/embed/${videoId}?rel=0&enablejsapi=1&autoplay=${autoplayValue}&mute=1&controls=1&loop=1&playlist=${videoId}`;
        } else {
            return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&enablejsapi=1&autoplay=${autoplayValue}&mute=1&controls=1&loop=1&playlist=${videoId}`;
        }
    }
}

export const youtubeProvider = new YoutubeProvider();
